function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isArray } from 'vega-util';
import { valueExpr, vgField } from './channeldef';
import { replaceExprRef } from './expr';
import { fieldExpr as timeUnitFieldExpr, normalizeTimeUnit } from './timeunit';
import { hasProperty, stringify } from './util';
import { isSignalRef } from './vega.schema';
export function isSelectionPredicate(predicate) {
  return hasProperty(predicate, 'param');
}
export function isFieldEqualPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.equal !== undefined;
}
export function isFieldLTPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.lt !== undefined;
}
export function isFieldLTEPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.lte !== undefined;
}
export function isFieldGTPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.gt !== undefined;
}
export function isFieldGTEPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.gte !== undefined;
}
export function isFieldRangePredicate(predicate) {
  if (predicate !== null && predicate !== void 0 && predicate.field) {
    if (isArray(predicate.range) && predicate.range.length === 2) {
      return true;
    } else if (isSignalRef(predicate.range)) {
      return true;
    }
  }
  return false;
}
export function isFieldOneOfPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && (isArray(predicate.oneOf) || isArray(predicate.in)) // backward compatibility
  ;
}
export function isFieldValidPredicate(predicate) {
  return !!(predicate !== null && predicate !== void 0 && predicate.field) && predicate.valid !== undefined;
}
export function isFieldPredicate(predicate) {
  return isFieldOneOfPredicate(predicate) || isFieldEqualPredicate(predicate) || isFieldRangePredicate(predicate) || isFieldLTPredicate(predicate) || isFieldGTPredicate(predicate) || isFieldLTEPredicate(predicate) || isFieldGTEPredicate(predicate);
}
function predicateValueExpr(v, timeUnit) {
  return valueExpr(v, {
    timeUnit: timeUnit,
    wrapTime: true
  });
}
function predicateValuesExpr(vals, timeUnit) {
  return vals.map(function (v) {
    return predicateValueExpr(v, timeUnit);
  });
}
// This method is used by Voyager. Do not change its behavior without changing Voyager.
export function fieldFilterExpression(predicate) {
  var useInRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var field = predicate.field;
  var normalizedTimeUnit = normalizeTimeUnit(predicate.timeUnit);
  var _ref = normalizedTimeUnit || {},
    unit = _ref.unit,
    binned = _ref.binned;
  var rawFieldExpr = vgField(predicate, {
    expr: 'datum'
  });
  var fieldExpr = unit ? // For timeUnit, cast into integer with time() so we can use ===, inrange, indexOf to compare values directly.
  // TODO: We calculate timeUnit on the fly here. Consider if we would like to consolidate this with timeUnit pipeline
  // TODO: support utc
  "time(".concat(!binned ? timeUnitFieldExpr(unit, field) : rawFieldExpr, ")") : rawFieldExpr;
  if (isFieldEqualPredicate(predicate)) {
    return "".concat(fieldExpr, "===").concat(predicateValueExpr(predicate.equal, unit));
  } else if (isFieldLTPredicate(predicate)) {
    var upper = predicate.lt;
    return "".concat(fieldExpr, "<").concat(predicateValueExpr(upper, unit));
  } else if (isFieldGTPredicate(predicate)) {
    var lower = predicate.gt;
    return "".concat(fieldExpr, ">").concat(predicateValueExpr(lower, unit));
  } else if (isFieldLTEPredicate(predicate)) {
    var _upper = predicate.lte;
    return "".concat(fieldExpr, "<=").concat(predicateValueExpr(_upper, unit));
  } else if (isFieldGTEPredicate(predicate)) {
    var _lower = predicate.gte;
    return "".concat(fieldExpr, ">=").concat(predicateValueExpr(_lower, unit));
  } else if (isFieldOneOfPredicate(predicate)) {
    return "indexof([".concat(predicateValuesExpr(predicate.oneOf, unit).join(','), "], ").concat(fieldExpr, ") !== -1");
  } else if (isFieldValidPredicate(predicate)) {
    return fieldValidPredicate(fieldExpr, predicate.valid);
  } else if (isFieldRangePredicate(predicate)) {
    var _replaceExprRef = replaceExprRef(predicate),
      range = _replaceExprRef.range;
    var _lower2 = isSignalRef(range) ? {
      signal: "".concat(range.signal, "[0]")
    } : range[0];
    var _upper2 = isSignalRef(range) ? {
      signal: "".concat(range.signal, "[1]")
    } : range[1];
    if (_lower2 !== null && _upper2 !== null && useInRange) {
      return 'inrange(' + fieldExpr + ', [' + predicateValueExpr(_lower2, unit) + ', ' + predicateValueExpr(_upper2, unit) + '])';
    }
    var exprs = [];
    if (_lower2 !== null) {
      exprs.push("".concat(fieldExpr, " >= ").concat(predicateValueExpr(_lower2, unit)));
    }
    if (_upper2 !== null) {
      exprs.push("".concat(fieldExpr, " <= ").concat(predicateValueExpr(_upper2, unit)));
    }
    return exprs.length > 0 ? exprs.join(' && ') : 'true';
  }
  /* istanbul ignore next: it should never reach here */
  throw new Error("Invalid field predicate: ".concat(stringify(predicate)));
}
export function fieldValidPredicate(fieldExpr) {
  var valid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (valid) {
    return "isValid(".concat(fieldExpr, ") && isFinite(+").concat(fieldExpr, ")");
  } else {
    return "!isValid(".concat(fieldExpr, ") || !isFinite(+").concat(fieldExpr, ")");
  }
}
export function normalizePredicate(f) {
  if (isFieldPredicate(f) && f.timeUnit) {
    return _objectSpread(_objectSpread({}, f), {}, {
      timeUnit: normalizeTimeUnit(f.timeUnit)
    });
  }
  return f;
}